import { ATSJobEditTestIds } from 'data-testids/ATS';
import { SubmitButton } from '.';
import { Input } from 'ui-kit';
import { useQueryGetVacanciesByJobId } from 'features/TabbedJobView/VacanciesTab/queries';
import { LocationVacancySchoolRole } from 'features/VacanciesModal/types';

export interface VacanciesInputProps {
  jobId: number;
  onClick: () => void;
}

export const renderSchoolLocations = (schools: LocationVacancySchoolRole[]) => {
  if (schools?.length === 0 || !schools) {
    return '';
  }

  let locationString = '';
  let stringLength = 0;
  let additionalSchools = 0;

  for (const school of schools) {
    const schoolName = school.school_name || '';
    stringLength += schoolName.length;
    if (stringLength < 90) {
      locationString += schoolName + ', ';
    } else {
      additionalSchools += 1;
    }
  }
  const additionalSchoolsString = additionalSchools > 0 ? ` + ${additionalSchools} more` : '';
  const finalString = `${locationString.slice(0, -2)}${additionalSchoolsString}`;
  return finalString;
};

export const VacanciesInput: React.FC<VacanciesInputProps> = ({ jobId, onClick }) => {
  const { data: schoolVacancies } = useQueryGetVacanciesByJobId(jobId);

  return (
    <>
      <Input
        width={1}
        style={{ backgroundColor: '#fff' }}
        type="text"
        placeholder="No locations selected"
        value={renderSchoolLocations(schoolVacancies?.schoolroles || []) || 'District Level'}
        disabled
        autoFocus
        data-testid={ATSJobEditTestIds.VACANCIES_INPUT}
      />
      <SubmitButton data-testid={ATSJobEditTestIds.LOCATIONS_MODAL_OPEN} onClick={onClick}>
        Edit Locations
      </SubmitButton>
    </>
  );
};
